import { ApiError } from '@api/models';
import { ApiErrors } from '@api/constants';

export function isInvalidOtp(error: ApiError) {
  return error?.errorCode === ApiErrors.INVALID_OTP || error?.errorCode === ApiErrors.INVALID_MOVIMENTS_OTP;
}
